// import { sortableHandle } from 'react-sortable-hoc';

import React from 'react';
import { Input, Form, Popover, Button } from 'antd';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import '../index.scss';

function OrgCombCell(formItemInfo) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: formItemInfo.record.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    display: 'inline-block',
    cursor: 'grab',
    userSelect: 'none',
  };

  const { record } = formItemInfo;
  const marginLeftValue = 60 * record.hierachy;
  const canHierachyBeDown = formItemInfo.canHierachyBeDown(record.id); // Adjust method name to yours

  const popoverContent = (
    <div className="popover-content">
      {record.hierachy > 0 && (
        <Button
          type="text"
          onClick={() => formItemInfo.handleAdd('Add Sibling', record.id)}
        >
          Add Sibling
        </Button>
      )}
      {record.hierachy > 1 && (
        <Button
          type="text"
          onClick={() =>
            formItemInfo.handleAdd('Add Parent Sibling', record.id)
          }
        >
          Add Parent Sibling
        </Button>
      )}
      <Button
        type="text"
        onClick={() => formItemInfo.handleAdd('Add Child', record.id)}
      >
        Add Child
      </Button>
    </div>
  );

  return (
    <div className="org-comb-cell" style={{ marginLeft: marginLeftValue }}>
      <div
        {...attributes}
        {...listeners}
        ref={setNodeRef}
        style={style}
        className="drag-handle"
      >
        <span className="appkiticon icon-menu-outline" />
      </div>

      {record.hierachy > 0 ? (
        <div
          className="left-button"
          onClick={() => formItemInfo.handleHierachyUp(record.id)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              formItemInfo.handleHierachyUp(record.id);
            }
          }}
        >
          <span className="appkiticon icon-arrow-left-outline" />
        </div>
      ) : (
        <div className="left-button disabled lock">
          <span className="appkiticon icon-arrow-left-outline" />
        </div>
      )}

      {canHierachyBeDown ? (
        <div
          className="right-button"
          onClick={() => formItemInfo.handleMoveDown(record.id)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              formItemInfo.handleMoveDown(record.id);
            }
          }}
        >
          <span className="appkiticon icon-arrow-right-outline" />
        </div>
      ) : (
        <div className="right-button disabled lock">
          <span className="appkiticon icon-arrow-right-outline" />
        </div>
      )}

      <Popover
        content={popoverContent}
        trigger="click"
        overlayClassName="org-add-popover"
        placement="bottom"
      >
        <div className="add-button" role="button" tabIndex={0}>
          <span className="appkiticon icon-plus" />
        </div>
      </Popover>

      {/* Uncomment and customize this if you need input */}
      {/* <Form.Item
           label={formItemInfo.label}
           name={formItemInfo.name}
           rules={formItemInfo.rules}
           style={{ display: 'inline-block', width: 'calc(100% - 180px)' }}
         >
           <Input {...formItemInfo.compProps} />
         </Form.Item> */}
    </div>
  );
}

export default OrgCombCell;
